﻿import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../.././shared/base.component';
import { SharedService } from '../.././shared/shared.service';

@Component({
    // moduleId: module.id,
    selector: 'fp-popup',
    templateUrl: 'popup.component.html'
})
export class PopupComponent extends BaseComponent implements OnInit {
    @Input() header: string;
    @Input() eclass :string = "";
    @Output() cancel = new EventEmitter();
    Ispopupopen: boolean = true;
    close($event) {
        this.cancel.emit({});
    }
    constructor( protected sharedService: SharedService, protected translate: TranslateService) {
        super(sharedService, translate);
    }
    ngOnInit() { }
    rightpanel() {        
        this.Ispopupopen = !this.Ispopupopen;
    }
}